import { DragHandle } from "@mui/icons-material";
import { IconButton, Theme, Tooltip } from "@mui/material";
import { SxProps } from "@mui/system";
import { forwardRef, Ref } from "react";
import { useTranslation } from "react-i18next";

export type ListDragHandleProps = {
    sx?: SxProps<Theme>;
};

function ListDragHandle({
    sx,
    ...rest
}: ListDragHandleProps, ref: Ref<HTMLButtonElement>) {
    const { t } = useTranslation();
    const tooltip = t("dragHandle.tooltip");
    
    return (
        <Tooltip title={tooltip} arrow>
            <IconButton
                sx={{
                    opacity: theme => theme.palette.action.disabledOpacity,
                    "&:focus, :hover": {
                        opacity: 1
                    },
                    touchAction: "none",
                    ...sx
                }}
                ref={ref}
                {...rest}
            >
                <DragHandle
                    sx={{
                        touchAction: "none"
                    }}
                />
            </IconButton>
        </Tooltip>
    );
}

export default forwardRef(ListDragHandle);